import React from "react";
import PainelAlertaPage from "./PainelAlertaPage";

function PainelAlertaPageConnected() {
  return <PainelAlertaPage />;
}

export default PainelAlertaPageConnected;
